import * as React from 'react';
import Layout, {LayoutProps} from '../../Layout';
import ResponsiveToggle from '../../ResponsiveToggle';

export default (props: LayoutProps) => (
  <Layout {...props}>
    <ResponsiveToggle off={true} />
    {props.children}
  </Layout>
);



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/Layout/Layout.tsx